
export const shinhancardRoutes = [
    {
        //path: "/shinhancard/shinhancardPickupGs25List",
        path: "/store-services/cardpickup/locations-select",
        alias: [
            "/gscvs/ko/store-services/cardpickup/locations-select"
        ],
        name: "ShinhancardPickupGs25List",
        component: () => import("@/views/shinhancard/ShinhancardPickupGs25List.vue"),
        meta: { 
            hideLayout: true 
        }        
    }
];